
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsAdvPromoHd6Grid extends Serenity.EntityGrid<PsAdvPromoHd6Row, any> {
        protected getColumnsKey() { return PsAdvPromoHd6Columns.columnsKey; }
        protected getDialogType() { return PsAdvPromoHd6Dialog; }
        protected getIdProperty() { return PsAdvPromoHd6Row.idProperty; }
        protected getInsertPermission() { return PsAdvPromoHd6Row.insertPermission; }
        protected getLocalTextPrefix() { return PsAdvPromoHd6Row.localTextPrefix; }
        protected getService() { return PsAdvPromoHd6Service.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();

            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );
            return buttons;

        }
    }
}